import { render } from "./ImportModal.vue?vue&type=template&id=56c04dc6&scoped=true"
import script from "./ImportModal.vue?vue&type=script&lang=ts"
export * from "./ImportModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-56c04dc6"

export default script